/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveConnections from './receive-connections';
import * as actions from 'state/action-types';

export default (connectionId = null, connection) => (dispatch) => {
    return cecSdk
        .connection(connectionId)
        .remove()
        .then(() => {
            dispatch({ type: actions.DELETE_CONNECTION_SUCCESS, payload: { connectionId } });
        });
};
